import { useLingui } from "@lingui/react";
import { FC, useMemo } from "react";
import { Helmet } from "react-helmet";
import { useTitle } from "react-use";

import { ITemplateMeta } from "@/components/features/polotno_templates/hooks";

export interface ITemplateHelmetProps {
  meta: ITemplateMeta;
}

const LOCALE_CODES = [
  "en_GB",
  "es_ES",
  "kk_KZ",
  "pt_PT",
  "ro_RO",
  "ru_RU",
  "uk_UA",
];

export const TemplateHelmet: FC<ITemplateHelmetProps> = ({ meta }) => {
  const {
    i18n: { locale },
  } = useLingui();

  useTitle(meta?.title || document.title);

  const ogLocale = useMemo(
    () => LOCALE_CODES.find((item) => item.startsWith(locale)),
    [locale],
  );

  const ogLocaleAlt = useMemo(
    () => LOCALE_CODES.filter((item) => !item.startsWith(locale)),
    [locale],
  );

  return (
    <Helmet>
      <title>{meta.title}</title>
      <link rel="canonical" href={meta.canonical} />
      <meta name="description" content={meta.desc} />
      {meta.author && <meta name="author" content={meta.author} />}
      {meta.keywords && <meta name="keywords" content={meta.keywords} />}

      <meta property="og:title" content={meta.name} />
      <meta property="og:description" content={meta.desc} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:type" content="profile" />
      <meta property="og:url" content={meta.canonical} />
      <meta property="og:locale" content={ogLocale} />

      {ogLocaleAlt.length &&
        ogLocaleAlt.map((locale) => (
          <meta key={locale} property="og:locale:alternate" content={locale} />
        ))}
    </Helmet>
  );
};
